import { IconProps } from "../../utils/global-types/global-types";

const SubtractIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 18 18"
    className={className ? className : "w-[18px] h-[18px]"}
    {...rest}
  >
    <g clipPath="url(#clip0_11377_122378)">
      <path
        fill="currentColor"
        d="M9 2C5.14 2 2 5.14 2 9s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7m3.063 7.583H5.937a.583.583 0 0 1 0-1.166h6.126a.583.583 0 0 1 0 1.166"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_11377_122378">
        <path fill="#fff" d="M2 2h14v14H2z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default SubtractIcon;
